import { render, staticRenderFns } from "./ChartCompetitionPlayers.vue?vue&type=template&id=c2a44c3c&scoped=true&"
import script from "./ChartCompetitionPlayers.vue?vue&type=script&lang=js&"
export * from "./ChartCompetitionPlayers.vue?vue&type=script&lang=js&"
import style0 from "./ChartCompetitionPlayers.vue?vue&type=style&index=0&id=c2a44c3c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2a44c3c",
  null
  
)

export default component.exports